import { ConversationSchemaDbParser } from "@redotech/redo-model/conversation/conversation-schema-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { object } from "zod/v4";
type GetConversationByIdSchema = {
  name: "getConversationById";
  input: z.ZodObject<{ conversationId: ReturnType<typeof zExt.objectId> }>;
  output: z.ZodObject<{ conversation: typeof ConversationSchemaDbParser }>;
};

export const getConversationById: GetConversationByIdSchema = {
  name: "getConversationById" as const,
  input: object({ conversationId: zExt.objectId() }),
  output: object({ conversation: ConversationSchemaDbParser }),
};
